


























































import { fetchRegistrar } from '../fetchRegistrar';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';

import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';

import {
  GridApi,
  ColumnApi,
  ColDef,
  CellContextMenuEvent,
  GridReadyEvent,
  SelectionChangedEvent,
  SelectionController,
  RowNode,
  CellClickedEvent,
  RowSelectedEvent,
  CellClassParams,
} from 'ag-grid-community';
import { differenceBy } from 'lodash';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    DatePicker,
  },
})
export default class General extends ComponenteBaseStepper {
  permisosActuales: PermisoAccionVm[] = [];
  permisosTotales: PermisoAccionVm[] = [];

  estados: any = [];
  usuarioNombre: string;

  async getInformacion() {
    let self = this;
    this.loadingService.showLoading();
    return fetchRegistrar(
      {
        usuario: JSON.parse(window.localStorage.user).id,
      },
      'conecta_registra_baja_sim/get_informacion_general'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.estados = data.data.ESTADOS;
          this.usuarioNombre = data.data.USUARIO[0].fullname;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Ocurrió un error al cargar la información general',
          { timeout: 3000 }
        );
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async cargarInformacion() {
    await this.getInformacion();
    this.formFields.usuario.value = this.usuarioNombre;
  }
  mounted() {
    this.cargarInformacion();
  }

  rules = {
    required: (value: any) => !!value || 'Required.',
  };

  formFields: {
    usuario: any;
    fecha: any;
    estado: any;
    accion: any;
  } = {
    usuario: {
      label: 'Usuario',
      value: '',
    },
    fecha: {
      label: 'Fecha',
      value: moment().format('YYYY/MM/DD HH:mm'),
    },
    estado: {
      label: 'Estado',
      value: '',
    },
    accion: {
      label: 'Acción',
      value: 'Confirmar',
    },
  };

  nuevoDato: any = {};

  // Globales
  $snotify: any;
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();

  //Interface
  editedItem: IFuncionalidad = {};

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
